Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-phone-form');
    var accountLoyaltyContentWrapper = $('.account-loyalty-account');
    var validationFormWrapper = $('.x-code-validation-form');

    if ($form.length <= 0)
        return;

    if (accountLoyaltyContentWrapper.length > 0) {
        $('a[data-showForm]').click(function (e) {
            var $text = $('.account-loyalty-account .consent-text-wrapper');
            $.fancybox.open($text, {
                maxWidth: 900,
                padding: 0,
                modal: true,
                beforeShow: function () {
                    var consentForm = $('.js-consent-form');
                    var closeButton = $('.js-consent-decline-button', consentForm);
                    var acceptButton = $('.js-consent-accept-button', consentForm);

                    closeButton.off('click').on('click', function () {
                        $.fancybox.close(true);
                    });
                    acceptButton.off('click').on('click', function () {
                        var data = [];

                        data.push({
                            type: consentForm.data('type'),
                            source: 'Loyalty Form',
                            approved: true
                        });

                        $.fancybox.close(true);
                        if (data.length > 0) {
                            window.ConsentsManager.insertConsents(data);
                        }


                    });
                }
            });
        });
    } else {
        InitPhoneForm(undefined, validationFormWrapper);
    }

    function InitPhoneForm(contentWrapper, validationWrapper) {

        var $submitFormButton, $loyaltyErrorWrapper, formData, valOpts, phoneFormPartial = "loyaltyPhoneForm_A",
            loyaltyRegistrationUrl;
        var $contentWrapper = contentWrapper;
        var $validationWrapper = validationWrapper.get(0);

        var form = $form.get(0);

        form.initForm = function (model) {
            form.loading(true);

            if ($contentWrapper) {
                $contentWrapper.addClass('hidcon');
            }

            loyaltyRegistrationUrl = model.LoyaltyRegistrationUrl;

            var html = Vendd.Handlebars.parse(phoneFormPartial, model);

            $form.html(html);
            form.bind();

            form.loading(false);
        }

        form.bind = function () {

            $('a[data-showForm]', $contentWrapper).hide();

            $loyaltyErrorWrapper = $('.loyalty-error-container');

            formData = {
                "mobile": $('input[name="mobile"]').val(),
                "mobileConfirm": $('input[name="mobileConfirm"]').val()
            };

            valOpts = {
                mobile: {
                    required: 'mobile-required'
                },
                mobileConfirm: {
                    required: 'mobileConfirm-required',
                    match: {
                        validator: 'mobileConfirm-match',
                        matchField: 'mobile'
                    }
                }
            };

            $('.consent-wrapper', $form).each(function (e, el) {
                var $chkbx = $('.checkbox-wrapper > input', el);
                var chkbxId = $chkbx.attr('id');
                if (chkbxId != undefined && chkbxId != "") {
                    formData[chkbxId] = $chkbx.val();
                    valOpts[chkbxId] = {
                        checkboxRequired: (chkbxId + '-required')
                    };
                }
                $chkbx.off('click').on('click', function () {

                    var $this = $(this);

                    if (!$this.is(':checked')) {

                        var fieldName = $this.attr('name');

                        formData[fieldName] = $this.is(':checked');
                        rf = $form.data('validationEngine');
                        rf.validate(fieldName);
                        return;
                    }

                    $this.prop("checked", false);

                });
            });

            $form.validationEngine(valOpts);
            var rf = $form.data('validationEngine');

            $submitFormButton = $('.js-phone-submit-button', $form);

            $form.on('click', '.js-phone-submit-button', function (e) {
                valOpts = $form.validationEngine();

                $form.validationEngine(valOpts);
                var rf = $form.data('validationEngine');

                var valid = rf.validate();

                if (valid) {
                    form.submitForm();
                }
            });

            $form.on('keyup', 'input[name]', function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();

                    $submitFormButton.click();
                    return;
                };

                var $this = $(this);
                var fieldName = $this.attr('name');

                formData[fieldName] = $this.val();
                rf = $form.data('validationEngine');
                rf.validate(fieldName);
            });
        }

        form.submitForm = function () {
            formData.mobile = $('input[name="mobile"]').val();

            if (formData.mobile) {
                Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.CheckByMobile(formData.mobile));
            }
        }

        form.hide = function () {
            var $this = $(this);

            $this.hide();
        }

        form.loading = function (loading) {
            if (loading) {
                $form.addClass('x-loading');
            } else {
                $form.removeClass('x-loading');
            }
        }

        form.setIsRegistered = function (isRegistered) {
            sessionStorage.setItem('LoyaltyIsRegistered', isRegistered);
        };


        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.CheckByMobileSuccess, form, function (envelope) {
            var data = envelope.message.data;
            if (data.StatusCode === 409) {
                var loyaltyErrorWrapper = $loyaltyErrorWrapper.get(0);
                $('span.error-message', loyaltyErrorWrapper).html(data.ResponseMessage);
                $loyaltyErrorWrapper.show();
                return;
            }

            form.setIsRegistered(data.StatusCode === 200);

            sessionStorage.setItem('LoyaltyMobilePhone', formData.mobile);
            if ($validationWrapper) {
                form.hide();
                $validationWrapper.InitValidationForm();
            } else {
                form.loading(true);
                window.location = loyaltyRegistrationUrl;
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.CheckByMobileFailure, form, function () {
            form.loading(false);
            toastr.error('Something went wrong');
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.GetPhoneFormSuccess, form, function (envelope) {
            form.initForm(envelope.message.data);
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.GetPhoneFormFailure, form, function () {
            toastr.error('Something went wrong');
        });

        Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.GetPhoneForm(LhApp.Context.Item.Id));
    }

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, accountLoyaltyContentWrapper, function () {
        InitPhoneForm(accountLoyaltyContentWrapper, validationFormWrapper);
    });
});